import { formatINR } from "../utils/formatters";

export default function WalletTab({ wallet }) {
    return (
        <div role="tabpanel">
            <div className="p-wallet-card">
                <p className="p-wallet-label">Wallet balance</p>
                <p className="p-wallet-bal">{formatINR(wallet.balance ?? 0)}</p>
            </div>
            <div className="p-upi-row">
                <div>
                    <p className="p-upi-label">UPI ID</p>
                    <p className="p-upi-val">{wallet.upi_id || "Not linked"}</p>
                </div>
                {wallet.upi_id ? (
                    <button
                        className="p-copy-btn"
                        onClick={() => navigator.clipboard?.writeText(wallet.upi_id)}
                    >
                        Copy
                    </button>
                ) : (
                    <button className="p-copy-btn">+ Link UPI</button>
                )}
            </div>
        </div>
    );
}